import { Badge, Box, CircularProgress, Grid, List, Stack, Typography } from "@mui/joy"
import { ListItem } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { triggerSair } from "../auth/AuthenticationSlice"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import React from "react"
import { triggerLoadNotificacoes } from "../notificacoes/NotificacoesSlice"

var styles = {
    navbar: {
        position: "relative",
        top: 0,
        boxShadow: "0px 1px 10px 1px",
        marginBottom: "5px",
        backgroundColor: "#DEDEDE",
        height: "40px",
        width: "100%"
    }
}



function NavBar() {

    var dispatch = useDispatch();
    var { processando, textoProcessamento } = useSelector((state) => state.dbs)

    var count = useSelector((state) => state.notificacoes.totalNaoVistas)

    React.useEffect(() => {
        dispatch(triggerLoadNotificacoes())
    }, []);

    return <Box sx={
        !window.location.href.includes("localhost") ?
            styles.navbar :
            { ...styles.navbar, backgroundColor: "#97df97" }
    }>
        <Grid container>
            <Grid xs={12}>
                <Stack direction="row">
                    <List orientation="horizontal">
                        <ListItem>
                            <Typography>
                                <Link to="/">Inicio</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/storage">Storage</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/notetaker">Notes</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/todos">TODOs</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/scripts/execucoes">Scripts</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/rpc">RPC</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Badge color="danger" badgeContent={count} size="sm" showZero={false}>
                                    <Link to="/notificacoes">Notificações</Link>
                                </Badge>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/livrudo">Livrudo</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/work">Work</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/closet/room">Closet</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link to="/scrapper">Scrapper</Link>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography>
                                <Link onClick={() => {
                                    dispatch(triggerSair())
                                }}>Sair</Link>
                            </Typography>
                        </ListItem>
                    </List>
                    <Box style={{
                        padding: "5px 10px",
                        justifyContent: "flex-end",
                        display: "flex",
                        width: "100%",
                        alignItems: "center"
                    }}>
                        <Typography style={{ padding: "0 10px" }}>
                            {textoProcessamento}
                        </Typography>
                        {processando ? <CircularProgress color="danger" variant="soft"
                            size="sm"></CircularProgress> :
                            <CheckCircleOutlineIcon style={{ color: "green" }} />}
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    </Box>
}

export default NavBar